/*
 * KAPSTAT — public Guidelines & Learning library. Surfaces the same education
 * modules participants get inside each survey, free to revisit. No answer keys
 * (those stay server-side); no login.
 */
import { Link } from 'react-router-dom';
import { studies } from './studies/index.js';
import { Wordmark } from './Wordmark.jsx';
import { ThemeToggle } from './ThemeToggle.jsx';
import { SubscribeCTA } from './Subscribe.jsx';
import './styles.css';

export default function Learn() {
  const withEdu = studies.filter((s) => (s.education || []).length);
  const scrollTo = (id) => (e) => { e.preventDefault(); document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' }); };

  return (
    <div className="app">
      <div className="topbar">
        <Link to="/" className="topbar__home"><Wordmark height={20} /></Link>
        <div className="topbar__study">Guidelines library</div>
        <ThemeToggle />
      </div>

      <div className="card">
        <span className="pill">Learn</span>
        <h1>Guidelines &amp; learning library</h1>
        <p className="muted">Concise, guideline-based refreshers from our KAP studies — the same modules you get inside each survey, free to revisit any time.</p>
        <p className="muted small">These are short learning summaries, <b>pending expert validation</b> — not a substitute for full clinical guidelines or your institution’s protocols.</p>
        <nav className="learn-toc" aria-label="Topics">
          {withEdu.map((s) => (
            <a key={s.slug} href={`#${s.slug}`} className="learn-toc__item" onClick={scrollTo(s.slug)}>{s.emoji} {s.shortTitle}</a>
          ))}
        </nav>
      </div>

      {withEdu.map((s) => (
        <div className="card" id={s.slug} key={s.slug} style={{ '--ca': s.accent }}>
          <span className="pill">{s.emoji} {s.topic}</span>
          <h2>{s.educationTitle || s.shortTitle}</h2>
          {s.educationBlurb && <p className="muted small">{s.educationBlurb}</p>}
          {(s.education || []).map((m) => (
            <div key={m.id} style={{ marginTop: 14 }}>
              <h3>{m.title}</h3>
              {m.points.map((p, i) => <div className="edu-point" key={i}>{p}</div>)}
              {m.tip && (
                <div className="edu-tip">
                  <span className="edu-tip__icon" aria-hidden="true">💡</span>
                  <span><b>Memory hook — </b>{m.tip}</span>
                </div>
              )}
            </div>
          ))}
          <div className="btn-row btn-row--end" style={{ marginTop: 16 }}>
            <Link className="btn btn--ghost" to={`/study/${s.slug}`}>Take the {s.shortTitle} survey →</Link>
          </div>
        </div>
      ))}

      <div className="card"><SubscribeCTA source="learn" /></div>

      <footer className="footer">
        <div className="footer__legal">KAPSTAT™ · anonymous &amp; secure · operated by Eddlynn Edtech Private Limited</div>
      </footer>
    </div>
  );
}
